import { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { QRCodeSVG } from "qrcode.react";
import loadImage from "../../../../assets/common/common/call.png";

interface Props {
    data: any;
    onClose: () => void;
    // QR 을 숨기되 같은 크기의 빈 영역을 남겨 레이아웃을 유지한다
    hideQr?: boolean;
}

const PrintColor = ({ data, onClose, hideQr = false }: Props) => {
    // console.log("data::::", data);

    const [imagesLoaded, setImagesLoaded] = useState(false);
    const totalImages = data.length;

    const loadedCountRef = useRef(0);

    const handleImageLoad = () => {
        loadedCountRef.current += 1;
        if (loadedCountRef.current === totalImages) {
            setImagesLoaded(true);
        }
    };

    useEffect(() => {
        if (imagesLoaded) {
            if (!data) return;
            const handleAfterPrint = () => {
                onClose();
                window.removeEventListener("afterprint", handleAfterPrint);
            };

            window.addEventListener("afterprint", handleAfterPrint);

            setTimeout(() => {
                window.print(); // 팝업 닫지 말고, print 먼저 실행
            }, 200);
        }
    }, [imagesLoaded, data]);

    return ReactDOM.createPortal(
        <div id="print-color" className="print-color px-12">
            {data.map((item: any, index: any) => {
                const isEmpty = Object.keys(item).length === 0;
                const isSendManager = item?.보내는담당자;
                const isSendPhoneNoManager = !isSendManager && item?.보내는핸드폰번호;

                return (
                    <div key={index}>
                        {isEmpty ? (
                            <div className="w-full h-80 mb-7 flex items-center justify-center" />
                        ) : (
                            <div className="mb-8 h-80 flex ml-[-20px]">
                                <div className="flex flex-col text-sm mt-5 w-[44%] min-w-[44%] max-w-[44%] overflow-hidden">
                                    <p className="text-[18px] pr-7 font-bold px-2 pt-[7px] mt-[60px] ml-20 pb-0.5">
                                        {item?.접수일자 ? item.접수일자 : <>&nbsp;</>}
                                    </p>
                                    <p className="text-[18px] pr-7 font-bold px-2 pt-1 pb-2 ml-20 mt-[4px] whitespace-nowrap">
                                        {item.B_L번호 ? item.B_L번호 : <>&nbsp;</>}
                                    </p>
                                    <p className="text-[18px] font-bold px-2 mt-[13px] pb-1.5 ml-20">1566-0685</p>
                                    <div className="flex">
                                        <div className="p-2 ml-[5px] flex flex-col w-[45%] min-w-[45%] max-w-[45%]">
                                            <p className="mt-[-2px] ml-[14px] self-end pr-[10px]">{item?.담당자명 ?? "-"}</p>

                                            {hideQr ? (
                                                <div className="w-[70px] h-[70px] mb-3 mt-[18px] ml-3 mr-5 shrink-0" />
                                            ) : (
                                                <QRCodeSVG
                                                    value={item.B_L번호}
                                                    width={70}
                                                    height={70}
                                                    className="mb-3 mt-[18px] ml-3 mr-5 shrink-0"
                                                />
                                            )}
                                            <img src={loadImage} alt="" onLoad={handleImageLoad} className="w-0 h-0 absolute" />
                                            <img src={loadImage} alt="" onLoad={handleImageLoad} className="w-0 h-0 absolute" />

                                            {/* <img
                                                onLoad={handleImageLoad}
                                                loading="eager"
                                                width={78}
                                                height={78}
                                                // className="mb-3 mt-[10px] ml-1 mr-5 shrink-0 scale-[0.9]"
                                                className="mb-3 mt-[10px] ml-[10px] shrink-0 scale-[0.9]"
                                                src={item.QR66x66}
                                                alt="QR66x66"
                                            /> */}
                                        </div>
                                        <div className="p-2 w-[50%] min-w-[50%] max-w-[50%]">
                                            <p className="mt-[15px] ml-[-10px] whitespace-wrap" style={{ wordBreak: "break-all" }}>
                                                {item.요청사항}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-col w-full">
                                    <div className="flex">
                                        <div className="flex flex-col w-full mt-3">
                                            <div className="flex w-full -ml-4 gap-3">
                                                <p className="px-3 h-[68px] font-bold text-5xl flex items-center justify-center">
                                                    {item?.센터코드}
                                                </p>
                                                <p className="h-[68px] whitespace-nowrap w-full font-bold text-3xl flex items-center justify-center">
                                                    {item?.센터명}
                                                </p>
                                            </div>
                                            <div className="flex h-11 -mt-1">
                                                <div className="flex h-11">
                                                    <p className="w-32 pl-1 flex items-center font-bold ml-[5px]">{item?.운임}</p>
                                                </div>
                                                <div className="flex">
                                                    <p className="pl-6 whitespace-nowrap flex items-center font-bold ">{item?.수량}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex items-center ml-10 justify-center min-w-32">
                                            {hideQr ? (
                                                <div className="w-[70px] h-[70px] ml-[64px] mt-[19px] shrink-0" />
                                            ) : (
                                                <QRCodeSVG
                                                    value={item.B_L번호}
                                                    width={70}
                                                    height={70}
                                                    className="ml-[64px] mt-[19px] shrink-0 shrink-0"
                                                />
                                            )}
                                            {/* <img
                                                onLoad={handleImageLoad}
                                                loading="eager"
                                                // className="ml-[70px] mt-[11px] shrink-0 scale-[0.9]"
                                                className="ml-[56px] mt-[11px] shrink-0 scale-[0.9]"
                                                width={78}
                                                height={78}
                                                src={item.QR66x66}
                                                alt="QR66x66"
                                            /> */}
                                        </div>
                                    </div>
                                    <div className="flex mt-1">
                                        <div className="flex flex-col pl-3 min-h-[64px]">
                                            <p
                                                className={`font-bold text-[14px] leading-[16px] overflow-hidden ${item?.보내는상호?.length + item?.보내는전화번호?.length >= 20 && "tracking-[0.8]"}`}
                                            >
                                                {item?.보내는상호} {item?.보내는전화번호}
                                            </p>

                                            <p className="text-[13px] tracking-[0.8] leading-[14px]">
                                                <span className="inline-block leading-[16px]">
                                                    {item?.보내는주소1} {item?.보내는주소2}{" "}
                                                    {isSendManager && `/ 담당자 ${item.보내는담당자}`}
                                                    {isSendPhoneNoManager && "/ "} {item?.보내는핸드폰번호 && item.보내는핸드폰번호}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex mt-[10px]">
                                        <div className="font-bold w-full rounded-br-xl flex flex-col pl-3 justify-center">
                                            <p className="text-[20px] tracking-[0.8] leading-[20px]">
                                                {item?.받는상호} {item?.받는전화번호}
                                            </p>

                                            <p className="text-[18px] leading-[18px]">
                                                {item?.받는주소1}
                                                {item?.받는주소2}
                                            </p>
                                            <p className="text-[18px]">
                                                {item?.받는담당자 && `담당자 ${item.받는담당자}`}
                                                {item?.받는핸드폰번호 && item?.받는담당자 && `/ `}
                                                {item.받는핸드폰번호}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>,
        document.body,
    );
};

export default PrintColor;
